<p-tabMenu [model]="tabItems" 
[activeItem]="activeItem"
 (activeItemChange)="onActiveTabChange($event)">
</p-tabMenu>